import { default as _91cartId_93qSS1aRcwyQMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/confirmation/[cartId].vue?macro=true";
import { default as _91invitationId_93TicBYyEl3zMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/decline-invitation/[invitationId].vue?macro=true";
import { default as confirmationoPBpzot5DRMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/decline-invitation/confirmation.vue?macro=true";
import { default as donation_45kioskYlEW1pXMdOMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/donation-kiosk.vue?macro=true";
import { default as _91token_93iTePb9LCuaMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/e-tickets/[token].vue?macro=true";
import { default as eventfT2GrkOmLtMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/event.vue?macro=true";
import { default as express_45checkinFVj4PlelcZMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/express-checkin.vue?macro=true";
import { default as prepaid_45registrationUWikKUNdIDMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/prepaid-registration.vue?macro=true";
import { default as registration_45closedpPwBny094cMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/registration-closed.vue?macro=true";
import { default as registrationam9QxsjrogMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/registration.vue?macro=true";
import { default as sponsor_45selectionxYQgRkjxNUMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/sponsor-selection.vue?macro=true";
import { default as ticket_45selectionbMBlbCUKIZMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/ticket-selection.vue?macro=true";
import { default as _91cartId_93KECllPITwbMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/checkout/[eventId]/[cartId].vue?macro=true";
import { default as indexyreDYYMtOCMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/fundraising/index.vue?macro=true";
import { default as _91cartId_93Zpeac4Ka6VMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/confirmation/[cartId].vue?macro=true";
import { default as _91invitationId_931HpaIZjU3vMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/decline-invitation/[invitationId].vue?macro=true";
import { default as confirmationCFV2rJ1rCdMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/decline-invitation/confirmation.vue?macro=true";
import { default as donation_45kioskh4yBKugF14Meta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/donation-kiosk.vue?macro=true";
import { default as eventDSpp7ye7eBMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/event.vue?macro=true";
import { default as _91fundraiser_id_93AZOuKCP2p6Meta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/fundraiser/[fundraiser_id].vue?macro=true";
import { default as confirmationEo8f39bkc1Meta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/invitation/[invitationId]/confirmation.vue?macro=true";
import { default as indexXtVmFgxl6dMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/invitation/[invitationId]/index.vue?macro=true";
import { default as indexynvBtsLs28Meta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/invitation/index.vue?macro=true";
import { default as registration_45closedSzxiw1xgk6Meta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/registration-closed.vue?macro=true";
import { default as registrationDsKq20WRRwMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/registration.vue?macro=true";
import { default as sponsor_45selectiongMvmcPlcqcMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/sponsor-selection.vue?macro=true";
import { default as ticket_45selectionOfLFpSlDpQMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/ticket-selection.vue?macro=true";
import { default as loginTOzLXb0KsGMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/login.vue?macro=true";
import { default as password_45resetiS9OTs9O1xMeta } from "/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/password-reset.vue?macro=true";
export default [
  {
    name: "attendance-id-confirmation-cartId",
    path: "/attendance/:id()/confirmation/:cartId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/confirmation/[cartId].vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-decline-invitation-invitationId",
    path: "/attendance/:id()/decline-invitation/:invitationId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/decline-invitation/[invitationId].vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-decline-invitation-confirmation",
    path: "/attendance/:id()/decline-invitation/confirmation",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/decline-invitation/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-donation-kiosk",
    path: "/attendance/:id()/donation-kiosk",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/donation-kiosk.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-e-tickets-token",
    path: "/attendance/:id()/e-tickets/:token()",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/e-tickets/[token].vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-event",
    path: "/attendance/:id()/event",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/event.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-express-checkin",
    path: "/attendance/:id()/express-checkin",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/express-checkin.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-prepaid-registration",
    path: "/attendance/:id()/prepaid-registration",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/prepaid-registration.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-registration-closed",
    path: "/attendance/:id()/registration-closed",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/registration-closed.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-registration",
    path: "/attendance/:id()/registration",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/registration.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-sponsor-selection",
    path: "/attendance/:id()/sponsor-selection",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/sponsor-selection.vue").then(m => m.default || m)
  },
  {
    name: "attendance-id-ticket-selection",
    path: "/attendance/:id()/ticket-selection",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/attendance/[id]/ticket-selection.vue").then(m => m.default || m)
  },
  {
    name: "checkout-eventId-cartId",
    path: "/checkout/:eventId()/:cartId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/checkout/[eventId]/[cartId].vue").then(m => m.default || m)
  },
  {
    name: "fundraising",
    path: "/fundraising",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/fundraising/index.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-confirmation-cartId",
    path: "/peer/:id()/confirmation/:cartId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/confirmation/[cartId].vue").then(m => m.default || m)
  },
  {
    name: "peer-id-decline-invitation-invitationId",
    path: "/peer/:id()/decline-invitation/:invitationId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/decline-invitation/[invitationId].vue").then(m => m.default || m)
  },
  {
    name: "peer-id-decline-invitation-confirmation",
    path: "/peer/:id()/decline-invitation/confirmation",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/decline-invitation/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-donation-kiosk",
    path: "/peer/:id()/donation-kiosk",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/donation-kiosk.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-event",
    path: "/peer/:id()/event",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/event.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-fundraiser-fundraiser_id",
    path: "/peer/:id()/fundraiser/:fundraiser_id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/fundraiser/[fundraiser_id].vue").then(m => m.default || m)
  },
  {
    name: "peer-id-invitation-invitationId-confirmation",
    path: "/peer/:id()/invitation/:invitationId()/confirmation",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/invitation/[invitationId]/confirmation.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-invitation-invitationId",
    path: "/peer/:id()/invitation/:invitationId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/invitation/[invitationId]/index.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-invitation",
    path: "/peer/:id()/invitation",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/invitation/index.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-registration-closed",
    path: "/peer/:id()/registration-closed",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/registration-closed.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-registration",
    path: "/peer/:id()/registration",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/registration.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-sponsor-selection",
    path: "/peer/:id()/sponsor-selection",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/sponsor-selection.vue").then(m => m.default || m)
  },
  {
    name: "peer-id-ticket-selection",
    path: "/peer/:id()/ticket-selection",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/[id]/ticket-selection.vue").then(m => m.default || m)
  },
  {
    name: "peer-login",
    path: "/peer/login",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/login.vue").then(m => m.default || m)
  },
  {
    name: "peer-password-reset",
    path: "/peer/password-reset",
    component: () => import("/opt/atlassian/pipelines/agent/build/public-pages/pages/peer/password-reset.vue").then(m => m.default || m)
  }
]